/**
 * Aplana el `stats` de cada balanceador a campos numericos sueltos sobre el
 * propio item.
 *
 * Hace falta por dos motivos:
 *
 * 1. Las columnas usan claves sinteticas (`stats_attempts`) porque CCTable no
 *    resuelve claves anidadas. Si esas claves no existen en el item, el orden
 *    local de `CDataTable` lee `item[columna]` y obtiene `undefined` en todas
 *    las filas, asi que no ordena nada.
 * 2. `CDataTable` ordena con
 *    `typeof value === "number" ? value : String(value).toLowerCase()`, asi que
 *    los contadores tienen que ser numeros de verdad: como texto, "10" iria
 *    antes de "2".
 *
 * `not_delivered` y `delivery_rate` no los manda el endpoint del listado (solo
 * el global, en `/stats/overview`), asi que se derivan aqui.
 */

export const NO_VALUE = null;

function toInt(stats, key) {
    const value = parseInt(stats[key], 10);
    return isNaN(value) ? NO_VALUE : value;
}

export function flattenGroupStats(item) {
    const stats = (item && item.stats) || {};
    const leadsIn = toInt(stats, "leads_in");
    const delivered = toInt(stats, "delivered");

    const notDelivered =
        leadsIn === NO_VALUE || delivered === NO_VALUE
            ? NO_VALUE
            : leadsIn - delivered;

    // Sin leads que entraran no hay proporcion que calcular.
    const deliveryRate =
        leadsIn === NO_VALUE || delivered === NO_VALUE || leadsIn <= 0
            ? NO_VALUE
            : (delivered / leadsIn) * 100;

    return {
        ...item,
        stats_attempts: toInt(stats, "attempts"),
        stats_leads_in: leadsIn,
        stats_ok: toInt(stats, "ok"),
        stats_delivered: delivered,
        stats_not_delivered: notDelivered,
        stats_delivery_rate: deliveryRate,
    };
}

/**
 * `adapterData` del `tableMixin`: recibe la respuesta entera y devuelve la
 * misma con los `_items` aplanados.
 */
export function adapterBalancerGroupsStats(response) {
    const items = (response && response._items) || [];
    return {
        ...response,
        _items: items.map(flattenGroupStats),
    };
}
